import { render, staticRenderFns } from "./IDelay.vue?vue&type=template&id=1ad62752&scoped=true&"
import script from "./IDelay.vue?vue&type=script&lang=js&"
export * from "./IDelay.vue?vue&type=script&lang=js&"
import style0 from "./IDelay.vue?vue&type=style&index=0&id=1ad62752&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad62752",
  null
  
)

export default component.exports